import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ReactVivus from "react-vivus";
import { truncateString } from "@utils";
import Button from "@ui/button";
import { IDType, SvgIconType } from "@utils/types";
import {
    BoxIconWrap,
    BoxIconInner,
    BoxIconImg,
    BoxIconContent,
    BoxIcontitle,
    BoxIconText,
    BoxIconBtn,
} from "./style";
import Vivus from "vivus";
import aa from "./linea-music-headphones.svg";
console.log("aa", aa);
import "./style.css";
const BoxIcon = ({
    id,
    icon,
    title,
    desc,
    path,
    className,
    index,
    ...restProps
}) => {
    let aaaaa = [
        <svg
            version="1.1"
            class="icon"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="64"
            height="64"
        >
            <g
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
            >
                <path
                    strokeDasharray={284}
                    strokeDashoffset={284}
                    d="M32 1h-6v9l-6 2-6-6-8 8 6 6-2 6H1v12h9l2 6-6 6 8 8 6-6 6 2v9h12v-9l6-2 6 6 8-8-6-6 2-6h9V26h-9l-2-6 6-6-8-8-6 6-6-2V1z"
                />
                <circle
                    strokeDasharray={38}
                    strokeDashoffset={38}
                    cx="32"
                    cy="32"
                    r="6"
                />
            </g>
            <style type="text/css" id="igtranslator-color" />
        </svg>,
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="64"
            height="64"
        >
            <g
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
            >
                <circle
                    strokeDasharray={25}
                    strokeDashoffset={25}
                    cx="32"
                    cy="19.001"
                    r="4"
                />
                <path
                    strokeDasharray={102}
                    strokeDashoffset={102}
                    d="M45 21.023C44.968 13.276 39.181 7 32 7s-13 6.276-13 14.023C19 31.046 31.979 47 31.979 47S45.043 31.046 45 21.023z"
                />
            </g>
            <path
                strokeDasharray={126}
                strokeDashoffset={126}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                d="M21 37h-9L1 57h62L52 37h-9"
            />
            <style type="text/css" id="igtranslator-color" />
        </svg>,
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="64"
            height="64"
        >
            <path
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                strokeDasharray={198}
                strokeDashoffset={198}
                d="M1 21c0 20 31 38 31 38s31-18 31-38c0-8.285-6-16-15-16-8.285 0-16 5.715-16 14 0-8.285-7.715-14-16-14C7 5 1 12.715 1 21z"
            />
            <style type="text/css" id="igtranslator-color" />
        </svg>,
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="64"
            height="64"
        >
            <path
                strokeDasharray={270}
                strokeDashoffset={270}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                d="M1 6v48l31 4 31-4V6l-31 4zm31 52V10"
            />
            <path
                strokeDasharray={163}
                strokeDashoffset={163}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                d="M43 8v19l4-2 4 2V7M7 16l19 2M7 26l19 2M7 36l19 2M7 46l19 2m31-12l-19 2m19 8l-19 2"
            />
            <style type="text/css" id="igtranslator-color" />
        </svg>,
        <svg
            version="1.0"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="64"
            height="64"
        >
            <circle
                strokeDasharray={119}
                strokeDashoffset={119}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                cx="44"
                cy="38"
                r="19"
            />
            <circle
                strokeDasharray={82}
                strokeDashoffset={82}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                cx="44"
                cy="38"
                r="13"
            />
            <path
                strokeDasharray={524}
                strokeDashoffset={524}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                d="M30 51H1v6h37v-1M27 45H3v6h27m-4-12H5v6h22m-1-12H1v6h25m3-12H3v6h23m9-12H1v6h28m11-7v-5H3v6h32M1 9h37v6H1z"
            />
            <style type="text/css" id="igtranslator-color" />
        </svg>,
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="64"
            height="64"
        >
            <path
                strokeDasharray={182}
                strokeDashoffset={182}
                fill="none"
                stroke="#086AD8"
                stroke-width="2"
                stroke-miterlimit="10"
                d="M11 53C5.477 53 1 48.523 1 43s4.477-10 10-10h2v20h-2zm42-20c5.523 0 10 4.477 10 10s-4.477 10-10 10h-2V33h2zm-40 3v-9s0-16 19-16 19 16 19 16v6"
            />
            <style type="text/css" id="igtranslator-color" />
        </svg>,
        <svg
            t="1671157925435"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8732"
            width="65"
            height="65"
        >
            <path
                stroke="#086AD8"
                strokeWidth={28}
                strokeDasharray={6746}
                strokeDashoffset={6746}
                fill="none"
                d="M927.939864 416.038097c-28.4141 0-53.948392 12.351174-71.547215 31.997861h-189.939298l134.327017-134.327017a95.99358 95.99358 0 1 0-90.489949-90.489949L575.963403 357.546009V167.606711a95.99358 95.99358 0 1 0-127.991441 0v189.939298L313.644945 223.218992a95.99358 95.99358 0 1 0-90.489948 90.489949L357.482014 448.035958H167.542716a95.99358 95.99358 0 1 0 0 127.99144h189.939298l-134.327017 134.327017a95.99358 95.99358 0 1 0 90.489948 90.489949L447.971962 666.517347v189.939297a95.99358 95.99358 0 1 0 127.991441 0v-189.939297l134.327016 134.327017a95.99358 95.99358 0 1 0 90.489949-90.489949L666.453351 576.027398h189.939298A95.99358 95.99358 0 1 0 927.939864 416.038097z"
                p-id="8733"
            ></path>
        </svg>,
    ];

    return (
        <BoxIconWrap>
            <BoxIconInner className={className} {...restProps}>
                {aaaaa[index]}

                <BoxIconContent>
                    {title && (
                        <BoxIcontitle>
                            {truncateString(title, 18, false)}
                        </BoxIcontitle>
                    )}
                    {desc && (
                        <BoxIconText>{truncateString(desc, 90)}</BoxIconText>
                    )}
                    {path && (
                        <BoxIconBtn>
                            <Button
                                path={path}
                                variant="texted"
                                icondistance="8px"
                                fontWeight={400}
                                icon="far fa-long-arrow-right"
                            >
                                进入详情
                            </Button>
                        </BoxIconBtn>
                    )}
                </BoxIconContent>
            </BoxIconInner>
        </BoxIconWrap>
    );
};

BoxIcon.propTypes = {
    id: IDType,
    title: PropTypes.string,
    desc: PropTypes.string,
    path: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(SvgIconType)]),
    className: PropTypes.string,
};

BoxIcon.defaultProps = {
    path: "/",
};

export default BoxIcon;
